module.exports = __webpack_public_path__ + "static/media/eimg.13a044f4.png";